import { CheckIcon, XMarkIcon } from "@heroicons/react/24/solid";
import Input from "src/components/form/Input";
import { classNames } from "src/helpers/classNames";

const PasswordValidationItem = ({ isWaiting = true, condition, title }) => (
  <div className="ml-3 mt-2 flex items-center">
    {isWaiting ? <XMarkIcon className="mr-1 h-5 w-5 text-gray-400" /> : condition ? <CheckIcon className="mr-1 h-5 w-5 text-green-500" /> : <XMarkIcon className="mr-1 h-5 w-5 text-red-500" />}

    <span className={classNames("text-sm font-normal", isWaiting ? "text-gray-400" : condition ? "text-green-500" : "text-red-500")}>{title}</span>
  </div>
);

const ResetPasswordForm = ({ password = "", setPassword = () => {}, confirmPassword = "", setConfirmPassword = () => {}, policy = {} }) => {
  const { min_length = 8, require_uppercase = false, require_lowercase = false, require_number = false, require_special = false } = policy;

  const isInitial = password === "";

  return (
    <>
      <div className="mb-4 grid gap-y-4">
        <div className="w-full">
          <Input
            inline={true}
            inputValue={password}
            label={"Password *"}
            inputType={"password"}
            inputName={"password"}
            onChange={(e) => setPassword(e.target.value)}
          />

          <PasswordValidationItem
            isWaiting={isInitial}
            condition={password.length >= min_length}
            title={`At least ${min_length} characters`}
          />

          {require_lowercase && (
            <PasswordValidationItem
              isWaiting={isInitial}
              condition={/[a-z]/.test(password)}
              title={"Contains one lowercase letter"}
            />
          )}

          {require_uppercase && (
            <PasswordValidationItem
              isWaiting={isInitial}
              condition={/[A-Z]/.test(password)}
              title={"Contains one uppercase letter"}
            />
          )}

          {require_number && (
            <PasswordValidationItem
              isWaiting={isInitial}
              condition={/[0-9]/.test(password)}
              title={"Contains one number"}
            />
          )}

          {require_special && (
            <PasswordValidationItem
              isWaiting={isInitial}
              condition={/[^\w\s]/.test(password)}
              title={"Contains one special character (@, #, $, %, etc.)"}
            />
          )}
        </div>

        <div className="w-full">
          <Input
            inline={true}
            inputValue={confirmPassword}
            label={"Confirm Password *"}
            inputType={"password"}
            inputName={"password"}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <PasswordValidationItem
            isWaiting={confirmPassword === ""}
            condition={password !== "" && password === confirmPassword}
            title={"Passwords match"}
          />
        </div>
      </div>
    </>
  );
};

export default ResetPasswordForm;
